import { shumwayOptions, OptionSet, Option } from "@awayfl/swf-loader";
var avm2Options = shumwayOptions.register(new OptionSet("AVM2"));
var options = avm2Options.register(new OptionSet("Runtime"));
export var traceRuntime = options.register(new Option("tr", "traceRuntime", "boolean", false, "trace runtime"));
export var traceExecution = options.register(new Option("tx", "traceExecution", "boolean", false, "trace execution"));
export var traceInterpreter = options.register(new Option("ti", "traceInterpreter", "boolean", false, "trace interpreter"));
export var debuggerMode = options.register(new Option("db", "debuggerMode", "boolean", true, "enable debugger mode"));
